<script>
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
export default {
    name: 'NumbersSetka',
    data() {
        return {

            numbers: [
                {
                    startValue: 0,
                    endValue: 25.68,
                    suffix: '%',
                    displayValue: 0.0,
                    text1: 'Планируемая доля рынка',
                    isBig: true,
                    img1: require('../../assets/image/numberPic_1.svg'),
                    decimalPlaces: 2,
                    dolyas: false
                },
                {
                    startValue: 0,
                    endValue: 2.5,
                    suffix: 'млн+',
                    displayValue: 0.0,
                    text1: 'Пользователей, планируемый ежемесячный прирост',
                    img1: require('../../assets/image/numberPic_2.svg'),
                    decimalPlaces: 1,
                    dolyas: false
                },
                {
                    startValue: 0,
                    endValue: 36,
                    suffix: 'к+',
                    displayValue: 0,
                    text1: 'Ежемесячное количество заключенных контрактов',
                    img1: require('../../assets/image/numberPic_3.svg'),
                    decimalPlaces: '',
                    dolyas: false
                },
                {
                    startValue: 0,
                    endValue: 3.8,
                    suffix: 'к+',
                    displayValue: 0,
                    text1: 'Ежемесячные отчисления образовательным учреждениям',
                    img1: require('../../assets/image/numberPic_4.svg'),
                    decimalPlaces: '1',
                    dolyas: false
                },
                {
                    img1: require('../../assets/image/numberPic_5.svg'),
                    isBig: true,
                    noAnimation: true,
                    text2: 'Доля пользователей:',
                    img3: require('../../assets/image/numberPic_5.svg'),
                    img4: require('../../assets/image/circle.png'),
                    dolyas: true

                },
                {
                    startValue: 0,
                    endValue: 13.21,
                    suffix: '%',
                    displayValue: 0,
                    text1: 'Среднее рост зарплаты, при увеличении единицы рейтинга',
                    img1: require('../../assets/image/numberPic_6.svg'),
                    decimalPlaces: '2',
                    dolyas: false
                },


            ],
            dolyas: [
                {
                    img2: require('../../assets/image/krug_1.png'),
                    list: 'Доля специалистов'
                },
                {
                    img2: require('../../assets/image/krug_2.png'),
                    list: 'Доля обр. учреждений'
                },
                {
                    img2: require('../../assets/image/krug_3.png'),
                    list: 'Доля компаний'
                },
                {
                    img2: require('../../assets/image/krug_4.png'),
                    list: 'Доля HR-агентов'
                },
            ]
        };
    },
    mounted() {
        this.animateNumbers();
        gsap.registerPlugin(ScrollTrigger);
        let mm = gsap.matchMedia();

        mm.add("(min-width: 1440px)", () => {
            gsap.fromTo('.number', { fontSize: 20 }, {
                duration: 2,
                scrollTrigger: {
                    trigger: '.numbers__content-title',
                    start: 'top top',
                },
                fontSize: 120,
                ease: 'power1.in'
            });
        }),
            mm.add("(max-width: 1439px)", () => {
                gsap.fromTo('.number', { fontSize: 20 }, {
                    duration: 2,
                    scrollTrigger: {
                        trigger: '.numbers__content-title',
                        start: 'top top',
                    },
                    fontSize: 75,
                    ease: 'power1.in'
                });
            })
    },
    methods: {
        animateNumbers() {
            this.numbers.forEach((item, index) => {
                if (item.noAnimation) {
                    // Пропускаем анимацию для статичных элементов
                    return;
                }
                const obj = { val: item.startValue };

                gsap.to(obj, {
                    val: item.endValue,
                    duration: 3, // Длительность анимации
                    ease: "power3.out",
                    onUpdate: () => {
                        // Форматируем значение с количеством знаков после запятой
                        const formattedValue = obj.val.toFixed(item.decimalPlaces);
                        // Обновляем массив напрямую, Vue 3 автоматически отреагирует на это изменение
                        this.numbers[index].displayValue = formattedValue;
                    },
                    scrollTrigger: {
                        trigger: `.numbers__content-title`,  // Привязываемся к уникальному классу
                        start: "top top", // Начало анимации, когда элемент появляется в зоне видимости
                    },
                });
            });
        },
    },
}
</script>

<template>
    <div class="numbers">
        <div class="container">
            <div class="numbers__content">
                <h2 class="numbers__content-title">Показатели Sobes Market в цифрах</h2>
                <div class="numbers__content">
                    <div class="numbers__content-list">
                        <div :class="['numbers__content-item', { big: item.isBig }, { dolyas: item.dolyas }]"
                            v-for="(item, itemIndex) in numbers" :key="`item-${itemIndex}`">
                            <h3 class="numbers__item-title">
                                <span class="number number-{{ itemIndex }}">{{ item.displayValue }}</span>
                                <span>{{ item.suffix }}</span>
                            </h3>
                            <p class="numbers__item-text">{{ item.text1 }}</p>
                            <img class="numbers__item-img" :src="item.img1" alt="">

                            <!-- Отображение "dolyas" только если у item.dolyas = true -->
                            <div v-if="item.dolyas">
                                <ul class="numbers__users-list">
                                    <p class="numbers__users-text">{{ item.text2 }}</p>
                                    <li v-for="(dolya, dolyaIndex) in dolyas" :key="`dolya-${dolyaIndex}`"
                                        class="numbers__users-item">
                                        <img :src="dolya.img2" alt="">{{ dolya.list }}
                                    </li>
                                </ul>
                            </div>

                            <!-- Отображение дополнительных изображений, если они существуют -->
                            <img v-if="item.img3" class="numbers__item-img" :src="item.img3" alt="">
                            <img v-if="item.img4" class="numbers__circle" :src="item.img4" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



<style scoped>
.numbers__content-list {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: 435px;
    gap: 30px;
}

.numbers__content-item {
    grid-column: span 3;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.numbers__content-item.big {
    grid-column: span 6;
}

.numbers__circle {
    position: absolute;
    bottom: 15px;
    right: 29px;
}


.numbers__content-item {
    position: relative;
    border-radius: 50px;
    border: 1px solid #D4DBDE;
    background: #F5F7F8;
    padding: 50px;

}

.numbers__content-title {
    color: #1A1A1A;
    font-family: Aeroport;
    font-size: 60px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 40px;
}

.numbers__item-img {
    position: absolute;
    top: 50px;
    left: 50px;
}

.numbers__item-title {
    color: #1A1A1A;
    font-family: Aeroport;
    font-size: 120px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
}

.numbers__item-title span {
    color: #1A1A1A;
    font-family: Aeroport;
    font-size: 45px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
}

.numbers__item-text {
    color: #80879C;
    font-family: Aeroport;
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    line-height: 150%;
}

.numbers__users-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: relative;
    z-index: 2;
}

.numbers__users-text {
    color: #1A1A1A;
    font-family: Aeroport;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 6px;
}

.numbers__users-item {
    color: #80879C;
    font-family: Aeroport;
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    line-height: 150%;
    display: flex;
    align-items: center;
    gap: 8px;
}

@media (max-width: 1440px) {
    .numbers__circle {
        width: 350px;
    }

    .numbers__content-item {
        padding: 30px;
    }

    .numbers__item-img {
        top: 30px;
        left: 30px;
    }
}

@media (max-width: 1100px) {
    .numbers__content-item {
        grid-column: span 12;
    }

    .numbers__content-item.big {
        grid-column: span 12;
    }
}
@media (max-width: 650px) {
    .numbers__content-title {
        font-size: 32px;
    }
    .numbers__content-list {
        grid-auto-rows: auto;
    }
    .numbers__content-item {
        height: 325px;
    }
    .numbers__content-item.dolyas {
        height: 686px;
    }
    .numbers__circle {
        width: 100%;
        max-width: 333px;
        right: 50%;
        bottom: auto;
        top: 19%;
        transform: translateX(50%);
    }
}
</style>